/* ============================================================
   AAR Jewels - recent searches for the predictive search modal.
   Stores the last few queries in localStorage and renders them
   into any [data-aar-recent] container inside the search modal.
   Pure enhancement - never blocks native search.
   ============================================================ */
(function () {
  var KEY = 'aar-recent-searches';
  var MAX = 6;

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
  }
  function write(arr) {
    try { localStorage.setItem(KEY, JSON.stringify(arr.slice(0, MAX))); } catch (e) {}
  }
  function add(q) {
    q = (q || '').trim();
    if (!q) return;
    var arr = read().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
    arr.unshift(q);
    write(arr);
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function searchUrl(q) {
    return '/search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
  }

  function render(container) {
    var arr = read();
    if (!arr.length) { container.hidden = true; container.innerHTML = ''; return; }
    container.hidden = false;
    container.innerHTML =
      '<div class="aar-recent__head"><span class="aar-recent__label">Recent searches</span>' +
      '<button type="button" class="aar-recent__clear" data-aar-recent-clear>Clear</button></div>' +
      '<div class="aar-recent__chips">' +
      arr.map(function (q) {
        return '<a class="aar-recent__chip" href="' + searchUrl(q) + '">' + esc(q) + '</a>';
      }).join('') +
      '</div>';
  }
  function renderAll(scope) {
    (scope || document).querySelectorAll('[data-aar-recent]').forEach(render);
  }

  // Capture: save the query when a search is actually run.
  function captureFromUrl() {
    if (location.pathname.indexOf('/search') === -1) return;
    try { add(new URLSearchParams(location.search).get('q')); } catch (e) {}
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form && form.matches && form.matches('form[action*="/search"]')) {
      var input = form.querySelector('input[name="q"]');
      if (input) add(input.value);
    }
  }, true);

  // Clear button (delegated).
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-aar-recent-clear]');
    if (!btn) return;
    e.preventDefault();
    write([]);
    renderAll();
  });

  function init() {
    captureFromUrl();
    renderAll();
    // The search component swaps the empty-state DOM in/out; re-render when it does.
    var modal = document.getElementById('search-modal');
    if (modal && 'MutationObserver' in window) {
      new MutationObserver(function () { renderAll(modal); }).observe(modal, { childList: true, subtree: true });
    }
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
